import { useState, useEffect, useMemo } from "react";
import { useFetchByFormNameQuery } from "@/api/services/dynamicForm/DynamicFormApi";

const useFetchFormData = (formName) => {
  const { data, error, isLoading } = useFetchByFormNameQuery(formName);

  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  const errorMessage = useMemo(() => {
    if (!error) return "";
    if (typeof error === "string") return error;
    if (error?.data?.message) return error.data.message;
    if (error?.error) return error.error;
    return "An unknown error occurred.";
  }, [error]);

  return {
    formData,
    setFormData,
    isLoading,
    errorMessage,
    hasError: Boolean(error),
  };
};

export default useFetchFormData;
